import { useTranslation } from '@flecto/translations'
import { type FlectoLanguages } from '@flecto/translations/src/types/FlectoLanguages'
import { type CoreBookingService } from '@flecto/types'

type ServiceKindInfo = {
  value: CoreBookingService['service_kind']
  label: string
}

export function useServiceKind(language?: FlectoLanguages) {
  const { t } = useTranslation('saas', {
    keyPrefix: 'booking_services',
    lng: language,
  })

  const kinds: ServiceKindInfo[] = [
    {
      value: 'cleaning',
      label: t('service_kind.cleaning'),
    },
    {
      value: 'transport',
      label: t('service_kind.transport'),
    },
    {
      value: 'operator',
      label: t('service_kind.operator'),
    },
    {
      value: 'insurance',
      label: t('service_kind.insurance'),
    },
    {
      value: 'logistic',
      label: t('service_kind.logistic'),
    },
    {
      value: 'others',
      label: t('service_kind.others'),
    },
  ]

  return kinds
}
